import classes from "./Button.module.scss";
import Cookies from 'js-cookie';
import { Link } from "react-router-dom";
import { useForm } from "../../../FormContext";

const Button = ({ children, route, white, form }) => {
  const lang = Cookies.get('i18next');
  const newRoute = `/${lang}/${route ?? 'contact'}`;
  const { openForm } = useForm();

  if (form) {
    return (
      <div
        onClick={openForm}
        className={`${classes.button} ${white ? classes.white : ''}`}
      >
        <span>{children}</span>
      </div>
    );
  }

  return (
    <Link
      to={newRoute}
      className={`${classes.button} ${white ? classes.white : ''}`}
    >
      <span>{children}</span>
    </Link>
  );
};

export default Button;
